import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import CookiePolicy from "./Component/CookiePolicy";
import FAQs from "./Component/FAQs";
import {
  AcceptableUsePolicy,
  AccessibilityStatement,
  CommunicationsPolicy,
  ComplaintsPolicy,
  ConsumerRightsPolicy,
  IntellectualPropertyNotice,
  OrdersPolicy,
  PaymentsPolicy,
  PolicyHub,
  PrivacyChoices,
  ProductPolicy,
  PromotionsPolicy,
  SecurityFraudPolicy,
  WarrantyCarePolicy,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/policies" element={<PolicyHub />} />
          <Route path="/privacy-choices" element={<PrivacyChoices />} />
          <Route path="/orders" element={<OrdersPolicy />} />
          <Route path="/payments" element={<PaymentsPolicy />} />
          <Route path="/product-policy" element={<ProductPolicy />} />
          <Route path="/warranty-care" element={<WarrantyCarePolicy />} />
          <Route path="/promotions" element={<PromotionsPolicy />} />
          <Route path="/acceptable-use" element={<AcceptableUsePolicy />} />
          <Route
            path="/intellectual-property"
            element={<IntellectualPropertyNotice />}
          />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/security" element={<SecurityFraudPolicy />} />
          <Route path="/consumer-rights" element={<ConsumerRightsPolicy />} />
          <Route path="/communications" element={<CommunicationsPolicy />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
